import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Order.css"; // File untuk styling
import { useLocation, useNavigate } from "react-router-dom";

function OrderDetail() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [orderDetail, setOrderDetail] = useState({
    orderItemlistByOrderId: [],
    orderFeedbackListByOrderId: [],
    orderApprovalListByOrderId: [],
    orderHistoryListByOrderId: [],
  });
  const [selectedType, setSelectedType] = useState("");
  const [selectedPriority, setSelectedPriority] = useState("");

  const resource = "order-detail";
  const storedToken = localStorage.getItem("token");
  const [authByToken, setAuthByToken] = useState("");
  const [showOrderHistory, setShowOrderHistory] = useState(false);
  const [showRemainingTime, setShowRemainingTime] = useState(false);
  const [durationInfo, setDurationInfo] = useState({});

  const loadUserByToken = async (token) => {
    const result = await axios.get(
      `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${token}`
    );
    setAuthByToken(result.data[0]);
  };

  useEffect(() => {
    if (authByToken?.xcp_role_code) {
      const status = [
        "XCPRLE-002",
        "XCPRLE-003",
        "XCPRLE-004",
        "XCPRLE-005",
      ].includes(authByToken.xcp_role_code);

      setShowOrderHistory(status);
      setShowRemainingTime(status);
    }
  }, [authByToken]);

  useEffect(() => {
    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
    if (storedToken) {
      loadUserByToken(storedToken);
    }
  }, []);

  useEffect(() => {
    typeSelected(orderDetail.order_type);
  }, [orderDetail]);

  useEffect(() => {
    prioritySelected(orderDetail.order_priority);
  }, [orderDetail]);

  function typeSelected(orderType) {
    if (orderType === "Interconnection to Other Tenant Device") {
      setSelectedType("type-one");
    } else if (orderType === "Interconnection to Your Own Device") {
      setSelectedType("type-two");
    }
  }

  function prioritySelected(orderPriority) {
    if (orderPriority === "Normal") {
      setSelectedPriority("priority-one");
    } else if (orderPriority === "High") {
      setSelectedPriority("priority-two");
    }
  }

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    loadOrderDetail(searchParams.get("param1"));
  }, []);

  const loadOrderDetail = async (xcpOrderId) => {
    try {
      const result = await axios.get(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/order/order-detail?param1=${xcpOrderId}`
      );
      const data = result.data;

      setOrderDetail(data);
    } catch (error) {
      console.error("Error loading order list:", error);
    }
  };

  useEffect(() => {
    getRemainingSLATime(searchParams.get("param1"));
  }, []);

  const getRemainingSLATime = async (xcpOrderId) => {
    try {
      const result = await axios.get(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/order/remaining-sla-time?orderId=${xcpOrderId}`
      );
      const data = result.data;

      setDurationInfo(data);
    } catch (error) {
      console.error("Error getRemainingSLATime:", error);
    }
  };

  const formatDate = (datetime) => {
    const date = new Date(datetime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };

  const formatDateFull = (datetime) => {
    const date = new Date(datetime);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  const downloadApprovalEvidence = async (orderId) => {
    try {
      // Step 1: Get the presigned download URL from your Lambda function
      const result = await axios.get(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/order/download-approval-evidence?orderId=${orderId}`
      );
      const downloadUrl = result.data.downloadUrl;

      // Step 2: Fetch the file from the presigned URL
      const response = await fetch(downloadUrl, {
        method: "GET", // Use GET to download the file
      });

      const fileName = result.data.fileName;

      // Step 3: Convert the response to a Blob and create a downloadable link
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); // Set the desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up after download
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <div className="container-order-input">
      <h1 className="main-title">Cross Connect Order Detail</h1>
      <div className="order-information-order-input">
        <div className="title-order-input">
          <h5>Order Information</h5>
        </div>
        <div className="radio-button">
          <label>Cross Connect Type</label>
          <div className="radio-button-option">
            <input
              type="radio"
              name="connect"
              id="connect-one"
              checked={selectedType === "type-one"}
              disabled
            />
            <label htmlFor="connect-one">
              Interconnection to other tenant device
            </label>
          </div>
          <div className="radio-button-option">
            <input
              type="radio"
              name="connect"
              id="connect-two"
              checked={selectedType === "type-two"}
              disabled
            />
            <label htmlFor="connect-two">
              Interconnection to your own device
            </label>
          </div>
        </div>
        <div className="textbox-gray">
          <label htmlFor="comboBox">Destination</label>
          <select id="comboBox" name="options" disabled>
            <option value="option1">{orderDetail.company_destination}</option>
          </select>
        </div>
        <div className="radio-button">
          <label>Order Priority</label>
          <div className="radio-button-option">
            <input
              type="radio"
              name="orderPriority"
              id="order-priority-one"
              checked={selectedPriority === "priority-one"}
              disabled
            />
            <label htmlFor="order-priority-one">Normal</label>
          </div>
          <div className="radio-button-option">
            <input
              type="radio"
              name="orderPriority"
              id="order-priority-two"
              checked={selectedPriority === "priority-two"}
              disabled
            />
            <label htmlFor="order-priority-two">High</label>
          </div>
        </div>
        <div className="textbox-gray">
          <label htmlFor="comboBox">Existing Order Status</label>
          <select id="comboBox" name="options" disabled>
            <option value="option1">{orderDetail.order_status}</option>
          </select>
          {/* //9 Completed, 10 rejected, 11 canceled */}
          {showRemainingTime &&
            ![9, 10, 11].includes(orderDetail.order_status_id) && (
              <label className="red-text">
                Remaining Time: {durationInfo.remainingTime}
              </label>
            )}
        </div>
        {/* Download Approval Evidence */}
        {selectedType == "type-one" &&
          !!orderDetail.approval_letter_path &&
          orderDetail.approval_letter_path.trim() !== "" && (
            <div className="download-letter-section">
              <label className="download-label">
                Download Approval Evidence
              </label>
              <div className="download-file-container">
                <button
                  type="button"
                  className="download-button"
                  onClick={() => {
                    downloadApprovalEvidence(searchParams.get("param1"));
                  }}
                >
                  Download
                </button>
              </div>
            </div>
          )}
      </div>

      <div className="box-two-part">
        <div className="requestor-information">
          <div className="title-box-order-input">
            <h5>Requestor Information (A-End)</h5>
          </div>
          <div className="textbox-gray">
            <label htmlFor="companyName">Company Name</label>
            <input
              type="text"
              placeholder={orderDetail.company_requestor}
              disabled
            />
          </div>
          <div className="textbox-gray">
            <label htmlFor="picName">PIC Name</label>
            <input
              type="text"
              placeholder={orderDetail.pic_requestor}
              disabled
            />
          </div>
          <div className="textbox-gray">
            <label htmlFor="contactEmail">Contact e-mail</label>
            <input
              type="text"
              placeholder={orderDetail.email_requestor}
              disabled
            />
          </div>
          <div className="textbox-gray">
            <label htmlFor="orderDate">Order Date</label>
            <input
              type="text"
              placeholder={formatDate(orderDetail.order_date)}
              disabled
            />
          </div>
          <div className="textbox-gray">
            <label htmlFor="comboBox" className="requestLocation">
              Request Location
            </label>
            <select id="comboBox" name="options" disabled>
              <option value="option1">{orderDetail.order_location_name}</option>
            </select>
          </div>
        </div>

        <div className="destination-information">
          <div className="title-box-order-input">
            <h5>Destination Information (B-End)</h5>
          </div>
          <div className="textbox-gray">
            <label htmlFor="companyName">Company Name</label>
            <input
              type="text"
              placeholder={orderDetail.company_destination}
              disabled
            />
          </div>
          <div className="textbox-gray">
            <label htmlFor="picName">PIC Name</label>
            <input
              type="text"
              placeholder={orderDetail.pic_destination}
              disabled
            />
          </div>
          <div className="textbox-gray">
            <label htmlFor="contactEmail">Contact e-mail</label>
            <input
              type="text"
              placeholder={orderDetail.email_destination}
              disabled
            />
          </div>
        </div>
      </div>

      {/*  */}
      {orderDetail.orderItemlistByOrderId &&
        orderDetail.orderItemlistByOrderId.length > 0 &&
        orderDetail.orderItemlistByOrderId.map((order) => (
          //  {orderDetail.orderItemlist.map((order) => (
          <div className="box-two-part">
            <div className="a-end-information">
              <div className="title-box-order-input">
                <h5>A-end Information</h5>
              </div>
              <div className="textbox-gray">
                <label htmlFor="comboBox">Cable Type</label>
                <select id="comboBox" name="options" disabled>
                  <option value="option1">{order.cable_type_a}</option>
                </select>
              </div>
              <div className="textbox-gray">
                <label htmlFor="comboBox">Interface</label>
                <select id="comboBox" name="options" disabled>
                  <option value="option1">{order.interface_name_a}</option>
                </select>
              </div>
              <div className="textbox-gray">
                <label htmlFor="comboBox">Floor</label>
                <select id="comboBox" name="options" disabled>
                  <option value="option1">{order.floor_name_a}</option>
                </select>
              </div>
              <div className="textbox-gray">
                <label htmlFor="comboBox">Room</label>
                <select id="comboBox" name="options" disabled>
                  <option value="option1">{order.room_name_a}</option>
                </select>
              </div>
              <div className="textbox-gray">
                <label htmlFor="rackId">Rack ID</label>
                <input type="text" placeholder={order.a_end_rack_id} disabled />
              </div>
              <div className="textbox-gray">
                <label htmlFor="cableQuantity">Cable Quantity</label>
                <input
                  type="text"
                  placeholder={order.cable_quantity}
                  disabled
                />
              </div>
            </div>

            <div className="b-end-information">
              <div className="title-box-order-input">
                <h5>B-end Information</h5>
              </div>
              <div className="textbox-gray">
                <label htmlFor="comboBox">Cable Type</label>
                <select id="comboBox" name="options" disabled>
                  <option value="option1">{order.cable_type_b}</option>
                </select>
              </div>
              <div className="textbox-gray">
                <label htmlFor="comboBox">Interface</label>
                <select id="comboBox" name="options" disabled>
                  <option value="option1">{order.interface_name_b}</option>
                </select>
              </div>
              <div className="textbox-gray">
                <label htmlFor="comboBox">Floor</label>
                <select id="comboBox" name="options" disabled>
                  <option value="option1">{order.floor_name_b}</option>
                </select>
              </div>
              <div className="textbox-gray">
                <label htmlFor="comboBox">Room</label>
                <select id="comboBox" name="options" disabled>
                  <option value="option1">{order.room_name_b}</option>
                </select>
              </div>
              <div className="textbox-gray">
                <label htmlFor="rackId">Rack ID</label>
                <input type="text" placeholder={order.b_end_rack_id} disabled />
              </div>
            </div>
          </div>
        ))}
      <div className="box-two-part">
        <div className="approval-history">
          <h5>Approval History</h5>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">User</th>
                <th scope="col" className="note-column">
                  Note
                </th>
              </tr>
            </thead>
            <tbody>
              {orderDetail.orderApprovalListByOrderId.map((order) => (
                <tr>
                  <td>{formatDate(order.approval_date)}</td>
                  <td>{order.username}</td>
                  <td className="note-column">{order.notes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="feedback-history">
          <h5>Feedback History</h5>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">User</th>
                <th scope="col" className="note-column">
                  Note
                </th>
              </tr>
            </thead>
            <tbody>
              {orderDetail.orderFeedbackListByOrderId.map((order) => (
                <tr>
                  <td>{formatDate(order.feedback_date)}</td>
                  <td>{order.username}</td>
                  <td className="note-column">{order.feedback}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {showOrderHistory && (
        <div className="box-two-part">
          <div className="approval-history">
            <h5>Order History</h5>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Date</th>
                  <th scope="col">User</th>
                  <th scope="col">Order Status</th>
                  <th scope="col" className="note-column">
                    Note
                  </th>
                </tr>
              </thead>
              <tbody>
                {orderDetail.orderHistoryListByOrderId.map((order) => (
                  <tr>
                    <td>{formatDateFull(order.create_date)}</td>
                    <td>{order.username}</td>
                    <td>{order.xcp_order_status_name}</td>
                    <td className="note-column">{order.notes}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default OrderDetail;
